// JsFromRoutes CacheKey e95a1037c7180765c834987f363d2b23
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@/utils/definePathHelper'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '(/:locale)/items'),
}
